import { Controller } from "@hotwired/stimulus"

// The form builder's Preview chrome (TASK-267.4, decision-76): the bar above
// the real submission wizard running in preview mode. Owns only the two
// controls that are about the preview itself, never about the form:
//
// - Desktop | Phone. Sets data-device on this element; wizard.scss's
//   `.wizard-preview[data-device="phone"]` rules narrow the wizard to app
//   width and switch it to its below-lg layout. A CSS switch rather than a
//   re-render, so answers survive the toggle.
// - Start Over. Reloads the modal's frame — a fresh wizard with empty
//   answers. A GET of the same preview URL; nothing was saved to undo.
//
// Close is the modal's own close action; Finish Preview lives in the wizard.
export default class extends Controller {
  static targets = ["deviceButton"]

  static ACTIVE = ["bg-gray-100", "text-blue-800"]
  static INACTIVE = ["text-gray-600", "hover:bg-gray-50"]

  setDevice(event) {
    const device = event.currentTarget.dataset.device
    if (!device) return

    this.element.dataset.device = device
    this.deviceButtonTargets.forEach(button => {
      const active = button.dataset.device === device
      button.setAttribute("aria-pressed", String(active))
      button.classList.remove(...this.constructor.ACTIVE, ...this.constructor.INACTIVE)
      button.classList.add(...(active ? this.constructor.ACTIVE : this.constructor.INACTIVE))
    })
  }

  startOver() {
    const frame = this.element.closest("turbo-frame")
    if (frame?.src) {
      frame.reload()
    } else {
      window.location.reload()
    }
  }
}
